import { Button, Card, CardActions, Grid, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faFile } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import { useTranslation } from "react-i18next";

interface Created {
  file: { fileId: string; fileName: string; Data: string }
}

const FormNonPreviewFile: React.FC<Created> = ({ file }) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Grid p={2} gap={2} alignItems="center" container wrap="nowrap">
        <FontAwesomeIcon icon={faFile as IconProp} size="lg" />
        <Typography
          variant="labelMedium"
          fontWeight="500"
          sx={{ wordBreak: "break-word", flex: 1, minWidth: 0 }}
        >
          {file.fileName}
        </Typography>
      </Grid>
      <CardActions sx={{ justifyContent: "center" }}>
        <Button
          size="small"
          component="a"
          href={`data:application/${file.fileName?.split('.').pop()};base64,${file.Data}`}
          download={file.fileName}
        >
          <FontAwesomeIcon
            icon={faDownload as IconProp}
            style={{ color: "#34727F", marginRight: "5px" }}
          />
          <Typography>{t("global.buttons.download", "Download")}</Typography>
        </Button>
      </CardActions>
    </Card>
  )
}

export default FormNonPreviewFile